export const parseTrackIdFromExamLink = examLink => {
  if (!examLink) return undefined;
  const matches = examLink.match(/\/tracks\/(\d+)\/exam/);
  return Number(matches === null || matches === void 0 ? void 0 : matches[1]);
};